import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // 权限
import {default as api} from './utils/api'
import 'amfe-flexible'
import {hasPermission} from "./utils/hasPermission";
import '@/utils/extensions/index.js'
import Print from 'vue-print-nb'
// 导入富文本编译器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编译器对应的样式
import '@/styles/quill/quill.core.css'
import '@/styles/quill/quill.snow.css'
import '@/styles/quill/quill.bubble.css'
import websocket from '@/utils/websocket';
Vue.prototype.$websocket = websocket;
// 将富文本编辑器注册为全局可用的组件
Vue.use(VueQuillEditor)
Vue.use(Print);
Vue.prototype.hasPerm = hasPermission
Vue.use(ElementUI)
Vue.prototype.api = api;
Vue.prototype.baseUrl = ''
if(process.env.NODE_ENV === 'development'){
  Vue.prototype.baseUrl = process.env.BASE_URL;
}
Vue.prototype.inputLenth100 = 100
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
//全局的常量
//生产环境时自动设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = (process.env.NODE_ENV != 'production')
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
})



// WEBPACK FOOTER //
// ./src/main.js